import { DataHeader, DataSource, Layout, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCountry extends Layout {
    dataheaderCountry: DataHeader;
    sourceCountry: DataSource;
    switchIsActive: Switch;
    tabGeneral: Tab;
    tabsetCountry: Tabset;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
